/* global FBAC */

import {
    templates_careers,
    templates_solutions_careers,
    templates_news_insights,
    templates_meta_autocomplete,
} from "./templates.js";

let careersConciergeInstance = null;

export const initCareersConcierge = () => {
    if (careersConciergeInstance) {
        return careersConciergeInstance;
    }

    if (typeof FBAC === "undefined" || !document.querySelector("#fbac-careers")) {
        return null;
    }

    careersConciergeInstance = new FBAC.default({
        input: "#query",
        inject: "#fbac-careers",
        url: "https://wood-search.funnelback.squiz.cloud/s/suggest.json",
        showOnFront: 5,
        urlParts: {
            show: 5,
            sort: 0,
        },
        highlight: false,
        loader: true,
        targetClass: {
            onOpen: "fbac__searched",
        },
        display: {
            headerOnNoResults: false,
            footerOnNoResults: false,
            scaffoldOnNoResults: false,
        },
        bindEvents: true,
        events: {
            afterFetch(query, data) {
                if (data.woodGlobal_news_insights?.length)
                    this.data.woodGlobal_insights =
                        data.woodGlobal_news_insights.filter((res) => {
                            return (
                                res.disp &&
                                res.disp.listMetadata &&
                                res.disp.listMetadata.pageType[0] &&
                                res.disp.listMetadata.pageType[0] !== "Other"
                            );
                        });
                if (data.woodGlobal_careers?.length)
                    this.data.woodGlobal_careers = data.woodGlobal_careers.filter(
                        (res) => {
                            return (
                                res.disp &&
                                res.disp.listMetadata &&
                                res.disp.listMetadata.pageType[0] &&
                                res.disp.listMetadata.pageType[0] !== "Other"
                            );
                        }
                    );
                if (data.woodGlobal_solutions?.length)
                    this.data.woodGlobal_solutions =
                        data.woodGlobal_solutions.filter((res) => {
                            return (
                                res.disp &&
                                res.disp.listMetadata &&
                                res.disp.listMetadata.pageType[0] &&
                                res.disp.listMetadata.pageType[0] !== "Other"
                            );
                        });
            },
        },
        fb: [
            {
                id: "woodGlobal_careers",
                templates: templates_careers,
                urlParts: {
                    collection: "wood~sp-push-careers",
                    profile: "autocomplete_careers",
                },
            },
            {
                id: "woodGlobal_news_insights",
                templates: templates_news_insights,
                urlParts: {
                    collection: "wood~sp-meta",
                    profile: "autocomplete_insights_news",
                },
            },
            {
                id: "woodGlobal_solutions",
                templates: templates_solutions_careers,
                urlParts: {
                    collection: "wood~sp-meta",
                    profile: "autocomplete_solutions",
                },
            },
            {
                id: "woodGlobal_metaAutocomplete",
                templates: templates_meta_autocomplete,
                urlParts: {
                    collection: "wood~sp-combined-meta",
                    profile: "_default",
                    show: 3,
                },
            },
        ],
        scaffold(templates) {
            return `
          ${templates.woodGlobal_metaAutocomplete.results}
          <div class="fbac__all-results concierge__results">
            <div class="fbac__autocomplete">
                <div class="fbac__autocomplete--column">
                    <h3 class="title concierge__subtitle">Career site</h3>
                    <ul>
                        ${templates.woodGlobal_careers.results}
                    </ul>
                    ${templates.woodGlobal_careers.noResults}
                </div>
                <div class="fbac__autocomplete--column">
                    <h3 class="title concierge__subtitle">News / Insights</h3>
                    <ul>
                        ${templates.woodGlobal_news_insights.results}
                    </ul>
                    ${templates.woodGlobal_news_insights.noResults}
                </div>
                <div class="fbac__autocomplete--column">
                <h3 class="title concierge__subtitle">Solutions</h3>
                    <ul>
                        ${templates.woodGlobal_solutions.results}
                    </ul>
                    ${templates.woodGlobal_solutions.noResults}
                </div>

            </div>
          </div>
        `;
        },
        globalTemplates: {
            header(query) {
                return `
                  <h2 class="concierge__title">${query}</h2>
                `;
            },
        },
    });

    careersConciergeInstance.init();
    return careersConciergeInstance;
};

export default initCareersConcierge;
